import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class AppMaintenanceGuard  {

  constructor(private readonly _router: Router) { }
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Promise<boolean | UrlTree> | Observable<boolean | UrlTree> {

    const envData: any = environment;
    let isAppInMaintenance: boolean = envData['inMaintanence'] || false;
    
    if (isAppInMaintenance) {
        this._router.navigate(['/not-found']);
        return false;
    }

    return true;

  }
}
